
declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const pushToDataLayer = (event: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(event);
  }
};
